import { useEffect, useState } from "react"

import PageLayout from "../PageLayout"
import Loader from "../../generic/Loader"

import runTransitionLogic from "../../../../../common/logic/runTransitionLogic.js"
import runLogic from "../../../../../common/logic/runLogic"

import { useStore } from "../Page"

//setup using the API
import { useQuery } from "@tanstack/react-query";
import useApi from "../../../hooks/useApi"

const TransitionLayer = ({ type, options, dispatch, config }) => {
    //console.log('[TransitionLayer] config: ', config)
    //console.log('[TransitionLayer] options: ', options)
    //console.log('[TransitionLayer] type: ', type)
    
    const [state, setState] = useStore((s) => s)
    const { getMe } = useApi()

    //manages when the components is ready to proceed.
    const [skip, setSkip] = useState(false)
  
    const createFrom = { entity: options.createFromEntity, id: options.createFromId }
    let result = {}

    //Load Entity and pass it along as data.
    if (options.createFromEntity) {
        //console.log('[TransitionLayer] Loading Entity: ', options.createFromEntity)
        const queryKey = `${options.createFromEntity}}/${options.createFromId}`
        result = useQuery({
            queryKey: [queryKey],
            queryFn: () => getMe(`${options.createFromEntity}/${options.createFromId}`)
        });
    }

    //On Load apply any transition you want to the loaded data :-) Amazing
    useEffect(() => {
        if (options.mode === 'new' && options.load ) {
            const transitionData = runTransitionLogic(state, config.transition.type, createFrom)
            const processedData = runLogic(transitionData, transitionData.entity) 
            setState(processedData, { replace: true })
            if (options.createFromEntity === undefined) setSkip(true)
        }
    }, [])

    useEffect(
        () => {
            if (result.data) {
                const enrichedAddData = { ...result.data.data, selectedItems: options.stepData?.selectedItems ?? [] }
                const transitionData = runTransitionLogic(state, config.transition.type, enrichedAddData)
                const processedData = runLogic(transitionData, transitionData.entity)
                //console.log('[TransitionLayer] Processed Data:', processedData)
                processedData.savedOn = new Date()
                setState(processedData)
            }

        }, [result.isSuccess]
    )


    if (result.isLoading) { return <Loader /> }

    if (result.isSuccess || skip) {
        //console.log('re-rendering PageLayout')

        return (
            <>
                <PageLayout type={type} options={options} dispatch={dispatch} />
            </>
        )
    }


}

export default TransitionLayer
